import '../sp-image-recognition/sp-image-recognition';
import '../sp-button/sp-button';
import '../sp-dialog/sp-default-dialog';

import {css, html, LitElement} from 'lit';
import {customElement, property, query} from 'lit/decorators.js';
import {perfectScrollbar} from "../../styles/3rd-party/perfect-scrollbar.styles";
import {
    SpImageRecognition,
    SpImageRecognitionGetPredictions, SpImageRecognitionGetTaxaForManualField,
    SpImageRecognitionGetTaxaForPredictions, SpImageRecognitionImage, SpImageRecognitionSelectEventPayload
} from "../sp-image-recognition/sp-image-recognition";
import {translateUppercase} from "@stefanholzapfel/lit-translate/dist/translateUppercase.directive";
import {getIcon} from "../../styles/icons";
import {SpDefaultDialog} from "../sp-dialog/sp-default-dialog";

@customElement('sp-image-recognition-container')
export class SpImageRecognitionContainer extends LitElement {

    static styles = [
        perfectScrollbar,
        // language=CSS
        css`
            :host {
                display: inline-block;
                position: relative;
                width: 100%;
            }
            
            sp-button {
                width: 100%;
            }
        `
    ]

    @property({type: Array})
    images: SpImageRecognitionImage[] = [];
    @property({type: Boolean})
    allowManualClassification = true;
    @property({type: String})
    label = "UI_COMPONENT_IMAGE_RECOGNITION_BUTTON";

    @property({type: Function})
    getPredictionsCallback: SpImageRecognitionGetPredictions;
    @property({type: Function})
    getTaxaForPredictionsCallback: SpImageRecognitionGetTaxaForPredictions;
    @property({type: Function})
    getTaxaForManualFieldCallback: SpImageRecognitionGetTaxaForManualField;

    @query('#dialog') dialog: SpDefaultDialog;

    protected render() {
        return html`
            <sp-default-dialog id="dialog"
                .fullHeight=${ true }
                .defaultClearContentOnHide=${false}
                .template=${html`
                    <sp-image-recognition
                        id="image-recognition"
                        .getPredictionsCallback=${ this.getPredictionsCallback }
                        .getTaxaForPredictionsCallback=${ this.getTaxaForPredictionsCallback }
                        .getTaxaForManualFieldCallback=${ this.getTaxaForManualFieldCallback }
                        @select=${ e => { 
                            this.dialog.hide();
                            this.dispatchEvent(new CustomEvent<SpImageRecognitionSelectEventPayload>('select', {
                                detail: e.detail,
                                bubbles: true,
                                cancelable: false,
                                composed: true,
                            }));
                        } }>
                    </sp-image-recognition>`}>
            </sp-default-dialog>
            <sp-button
                .text=${ translateUppercase(this.label) }
                containerPosition="center"
                textToIconPadding="0"
                iconAreaWidth="35px"
                textToBorderPadding="10px"
                .icon=${ `url(${ getIcon('ai') })` }
                ?disabled=${ !this.images || !Array.isArray(this.images) || this.images.length === 0 }
                @click=${ () => {
                    const imageRecognition = this.dialog.getElementFromDialogById('image-recognition') as SpImageRecognition;
                    imageRecognition.images = [... this.images];
                    this.dialog.show() } }>
            </sp-button>`;
    }

}